<template>
	<core-modal
		name="create-campaign-modal"
		class="omapi-modal create-campaign-modal"
		:click-to-close="!isCreatingCampaign"
		:child-refs="$refs"
		header-text="Create Campaign"
	>
		<modals-content>
			<form @submit.prevent="doCreate">
				<label for="campaignName">What do you want to call your campaign?</label><br />
				<input
					ref="toFocus"
					v-model="name"
					type="text"
					name="campaignName"
					class="omapi-input"
					placeholder="My WordPress Campaign"
					@keydown.esc="name = ''"
				/>
				<br />
				<core-loading-button color="blue" type="primary" :loading="isCreatingCampaign" button-type="submit">
					Start Building
				</core-loading-button>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	props: {
		fromPlaybook: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isCreatingCampaign: false,
			name: null,
			error: null,
		};
	},
	computed: {
		...mapState('templates', {
			template: 'activeTemplate',
		}),
		campaignData() {
			return {
				name: this.name || 'My WordPress Campaign',
				sites: [this.$siteId],
				template: this.template.id,
				type: this.template.type,
				fromPlaybook: this.fromPlaybook,
			};
		},
	},
	methods: {
		...mapActions('campaigns', ['createCampaign']),
		doCreate() {
			if (this.isCreatingCampaign) {
				return false;
			}

			this.isCreatingCampaign = true;
			this.createCampaign(this.campaignData)
				.then(({ id }) => {
					window.location.href = this.$urls.builderLink(id, 'edit/?isNew=true');
				})
				.catch(() => {
					this.$modal.hide('create-campaign-modal');
				});
		},
	},
};
</script>
